import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import api from "./lib/api";

// Pages
import HomePage from "./pages/HomePage";
import RecipesPage from "./pages/RecipesPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import RecipeFormPage from "./pages/RecipeFormPage";
import TipsPage from "./pages/TipsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import FavoritesPage from "./pages/FavoritesPage";
import MyRecipesPage from "./pages/MyRecipesPage";
import WeeklyPackPage from "./pages/WeeklyPackPage";
import PackHistoryPage from "./pages/PackHistoryPage";
import PackDetailPage from "./pages/PackDetailPage";
import AdminPage from "./pages/AdminPage";
import AIPage from "./pages/AIPage";
import SubmitTipPage from "./pages/SubmitTipPage";
import DossiersPage from "./pages/DossiersPage";
import DossierDetailPage from "./pages/DossierDetailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AccountPage from "./pages/AccountPage";
import GuidePage from "./pages/GuidePage";
import DealsPage from "./pages/DealsPage";
import ContactPage from "./pages/ContactPage";

// Component to track page visits
function PageTracker() {
    const location = useLocation();
    
    useEffect(() => {
        // Track page visit (fire and forget)
        api.trackVisit(location.pathname, document.referrer);
    }, [location.pathname]);
    
    return null;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <PageTracker />
                <div className="App min-h-screen flex flex-col bg-background w-full max-w-full overflow-x-hidden">
                    <Navbar />
                    <main className="flex-1 w-full max-w-full">
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/weekly-pack" element={<WeeklyPackPage />} />
                            <Route path="/weekly-pack/:packId" element={<PackDetailPage />} />
                            <Route path="/packs/history" element={<PackHistoryPage />} />
                            <Route path="/recipes" element={<RecipesPage />} />
                            <Route path="/recipes/new" element={<RecipeFormPage />} />
                            <Route path="/recipes/:id" element={<RecipeDetailPage />} />
                            <Route path="/recipes/:id/edit" element={<RecipeFormPage />} />
                            <Route path="/tips" element={<TipsPage />} />
                            <Route path="/tips/submit" element={<SubmitTipPage />} />
                            <Route path="/deals" element={<DealsPage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/reset-password" element={<ResetPasswordPage />} />
                            <Route path="/account" element={<AccountPage />} />
                            <Route path="/guide" element={<GuidePage />} />
                            <Route path="/subscription" element={<SubscriptionPage />} />
                            <Route path="/subscription/success" element={<SubscriptionPage />} />
                            <Route path="/favorites" element={<FavoritesPage />} />
                            <Route path="/my-recipes" element={<MyRecipesPage />} />
                            <Route path="/admin" element={<AdminPage />} />
                            <Route path="/ai" element={<AIPage />} />
                            <Route path="/dossiers" element={<DossiersPage />} />
                            <Route path="/dossiers/:slug" element={<DossierDetailPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
